function toWebpSrc(src) {
  return src.replace(/\.(jpe?g|png)$/i, '.webp');
}

function normalizePublicUrl(src) {
  if (!src) {
    return '';
  }

  if (/^https?:\/\//i.test(src)) {
    return src;
  }

  const publicUrl = process.env.PUBLIC_URL || '';
  if (src.startsWith(publicUrl)) {
    return src;
  }

  return `${publicUrl}${src.startsWith('/') ? src : `/${src}`}`;
}

function getPreloadCandidates(src) {
  const normalized = normalizePublicUrl(src);

  if (/\.png$/i.test(normalized)) {
    return [normalized];
  }

  if (/\.jpe?g$/i.test(normalized) && (
    normalized.includes('/card_photos/')
    || /productpage\.jpe?g$/i.test(normalized)
  )) {
    return [toWebpSrc(normalized), normalized];
  }

  return [normalized];
}

function loadImage(src) {
  const candidates = getPreloadCandidates(src);

  return new Promise((resolve) => {
    let candidateIndex = 0;

    const tryNext = () => {
      if (candidateIndex >= candidates.length) {
        resolve(false);
        return;
      }

      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => {
        candidateIndex += 1;
        tryNext();
      };
      img.src = candidates[candidateIndex];
    };

    tryNext();
  });
}

function loadImages(sources, { concurrency = 12 } = {}) {
  const uniqueSources = [...new Set(sources.filter(Boolean))];

  if (uniqueSources.length === 0) {
    return Promise.resolve(true);
  }

  let nextIndex = 0;

  const worker = async () => {
    while (nextIndex < uniqueSources.length) {
      const currentIndex = nextIndex;
      nextIndex += 1;
      await loadImage(uniqueSources[currentIndex]);
    }
  };

  const workerCount = Math.min(concurrency, uniqueSources.length);
  return Promise.all(Array.from({ length: workerCount }, worker)).then(() => true);
}

export {
  getPreloadCandidates,
  loadImage,
  loadImages,
  normalizePublicUrl,
  toWebpSrc,
};
